import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import MainLogo from "../../../../images/main-logo.svg";
import CheckSuccess from "../../../../images/success-checkmark.png";
import "./GiftSuccess.scss";
import Header from '../../../pages/Header/Header.tsx';
import Footer from '../../../pages/Footer/Footer.tsx';

function GiftSuccess() {
  const [searchParams] = useSearchParams();
  const giftId = searchParams.get('giftId');

  useEffect(() => {
    // Clear any form data or context that might allow going back
    if (giftId) {
      console.log('Gift payment completed successfully for gift:', giftId);
      // Clear any cached gift data from localStorage to prevent going back to edit
      localStorage.removeItem('currentGiftData');
      localStorage.removeItem('giftFormData');
    }
    // Clear the gift completion flag to ensure it doesn't persist
    sessionStorage.removeItem('giftCompletionInProgress');
  }, [giftId]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header activeTab="6" toggle={() => {}} />

      <section className='gift-success-screen' style={{ flex: '1 0 auto' }}>
        <motion.div
          className='gift-success-screen-block'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className='gift-success-screen-in'>
            <div>
              {/* Critical content - no animation delay for better LCP */}
              <h1 className="success-title">
                Success!
              </h1>

              <p className="success-subtitle">
                Your Gift Has Been Created
              </p>

              <motion.div
                className="success-icon-container"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                {/* Simplified wave animations - only 2 waves instead of 4 */}
                <motion.div
                  className="wave-circle wave-1"
                  animate={{
                    scale: [1, 1.6],
                    opacity: [0.3, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeOut"
                  }}
                />
                <motion.div
                  className="wave-circle wave-2"
                  animate={{
                    scale: [1, 1.6],
                    opacity: [0.2, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeOut",
                    delay: 0.6
                  }}
                />

                {/* Main Checkmark Circle - appears quickly */}
                <motion.div
                  className="success-checkmark"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.3, type: "spring" }}
                >
                  <img
                    src={CheckSuccess}
                    alt="Success"
                    width={80}
                    loading="eager"

                    fetchPriority="high"
                  />
                </motion.div>
              </motion.div>

              {/* Critical LCP element - NO DELAY */}
              <div
                style={{
                  margin: "30px auto",
                  maxWidth: "450px",
                  textAlign: "left",
                }}
              >
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li
                    style={{
                      fontSize: "15px",
                      color: "#6b7280",
                      lineHeight: 1.6,
                      marginBottom: "12px",
                      paddingLeft: "28px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "2px",
                        color: "#3957A0",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      ✓
                    </span>
                    When the time comes, your gift and audio card will be delivered just as you intended.
                  </li>
                  <li
                    style={{
                      fontSize: "15px",
                      color: "#6b7280",
                      lineHeight: 1.6,
                      marginBottom: "12px",
                      paddingLeft: "28px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "2px",
                        color: "#3957A0",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      ✓
                    </span>
                    Your gift has been successfully created and is ready to be sent to your recipient!
                  </li>
                  <li
                    style={{
                      fontSize: "15px",
                      color: "#6b7280",
                      lineHeight: 1.6,
                      marginBottom: "12px",
                      paddingLeft: "28px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "2px",
                        color: "#3957A0",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      ✓
                    </span>
                    We've sent a confirmation email with all the details to your inbox.
                  </li>
                  <li
                    style={{
                      fontSize: "15px",
                      color: "#6b7280",
                      lineHeight: 1.6,
                      marginBottom: "0",
                      paddingLeft: "28px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "2px",
                        color: "#3957A0",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      ✓
                    </span>
                    You can return anytime to add more messages, gifts, recipients.
                  </li>
                </ul>
              </div>

              <motion.div
                className="success-buttons"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <Link to="/my-gifts">
                  <motion.button
                    className="back-to-gifts-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Back to My Gifts
                  </motion.button>
                </Link>
                <Link to="/start-gift">
                  <motion.button
                    className="send-another-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Send Another Gift
                  </motion.button>
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
}

export default GiftSuccess;